// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wcmc","colBig":"styles_colBig__2e2HS","colSmall":"styles_colSmall__HQJkk"};